var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"5"}},[_c('galeri-listesi',{on:{"updateToImages":function($event){return _vm.handlerResim($event)}}})],1),_c('b-col',{attrs:{"md":"7"}},[_c('galeri-gorselleri',{attrs:{"updateData":_vm.updateData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }